import React, { useEffect, useState } from "react";

const About = () => {
  const statsData = [
    { label: "Hotels Onboarded", value: 5 },
    { label: "Happy Clients", value: 5 },
    { label: "Cities Covered", value: 5 },
  ];

  const [stats, setStats] = useState(statsData.map(() => 0));

  // Optional: simple animation for stats count
  useEffect(() => {
    const interval = setInterval(() => {
      setStats((prev) =>
        prev.map((val, idx) => (val < statsData[idx].value ? val + 1 : val))
      );
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="about" className="bg-gray-900 text-gray-300 py-16">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="space-y-8 md:space-y-12">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-400">
            About Hotel-Hub
          </h2>

          <div className="space-y-6 text-center md:text-left">
            <p>
              Established in 2020, <strong>HOTEL-HUB</strong> is an all-in-one hotel
              booking and management platform designed to make hotel operations smarter
              and easier. From seamless room reservations to detailed sales reports, we
              empower hotels to manage everything under one roof.
            </p>
            <p>
              Our mission is to help hoteliers save time, reduce costs, and grow their
              business by offering a powerful yet user-friendly system that adapts to
              their needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center mt-12">
            {statsData.map((stat, idx) => (
              <div key={idx} className="bg-gray-800 rounded-xl p-6 shadow-lg">
                <h3 className="text-4xl font-bold text-blue-400 mb-2">
                  {stats[idx]}
                </h3>
                <p className="text-gray-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
